"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MODES = exports.DSP_API_URLS = exports.AppSwitcher = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));
var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _styles = require("@material-ui/core/styles");
var _Apps = _interopRequireDefault(require("@material-ui/icons/Apps"));
var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));
var _ReportProblem = _interopRequireDefault(require("@material-ui/icons/ReportProblem"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../Button"));
var _CircularProgress = _interopRequireDefault(require("../CircularProgress/CircularProgress"));
var _ProofpointLogo = _interopRequireDefault(require("../ProofpointLogo"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
var _DSP_API_URLS;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var styles = function styles(theme) {
  return {
    appGroup: {
      marginBottom: theme.spacing(2)
    },
    appOption: {
      '&$listItemFocusVisible': {
        backgroundColor: theme.palette.opacity.black[14]
      },
      borderLeft: '4px solid transparent',
      maxHeight: theme.spacing(6),
      padding: theme.spacing(1.5, 2.5)
    },
    appOptionIcon: {
      marginRight: theme.spacing(1.5)
    },
    appOptionLabel: {
      paddingLeft: 0,
      paddingRight: 0
    },
    appOptionLabelPrimary: {
      fontSize: '13px'
    },
    appOptionSelected: {
      '&.Mui-selected': {
        backgroundColor: theme.palette.opacity.primary[800][8],
        borderLeft: "4px solid ".concat(theme.palette.primary.main)
      }
    },
    backdrop: {
      backgroundColor: 'rgba(0,0,0,0.38)'
    },
    drawerIconButton: {
      '&:focus $drawerIconLabel': {
        backgroundColor: 'transparent',
        border: "2px solid ".concat(theme.palette.opacity.black[60]),
        borderRadius: '50%'
      },
      '&:hover': {
        backgroundColor: theme.palette.opacity.primary[800][8],
        color: theme.palette.primary.main
      },
      /**
       * "To style links appropriately, put the :active
       * rule after all other link-related rules,
       * as defined by the LVHA-order: :link — :visited — :hover — :active."
       * https://developer.mozilla.org/en-US/docs/Web/CSS/:active
       */
      // eslint-disable-next-line sort-keys
      '&:active': {
        backgroundColor: theme.palette.opacity.primary[800][14],
        color: theme.palette.primary.main
      },
      backgroundColor: theme.palette.common.white,
      borderRadius: 0,
      color: theme.palette.opacity.black[60],
      fontSize: theme.spacing(3),
      height: theme.spacing(7),
      padding: 0,
      width: theme.spacing(7)
    },
    drawerIconLabel: {
      height: theme.spacing(5),
      width: theme.spacing(5)
    },
    errorContainer: {
      margin: theme.spacing(24, 3, 0, 3),
      textAlign: 'center'
    },
    errorDescription: {
      color: theme.palette.opacity.black[60]
    },
    errorIcon: {
      color: theme.palette.opacity.black[60],
      height: theme.spacing(6),
      width: theme.spacing(6)
    },
    header: {
      fontWeight: 500,
      padding: theme.spacing(0.75, 3)
    },
    home: {
      marginLeft: 'auto'
    },
    iconButton: {
      '&:focus $iconLabel': {
        border: "2px solid ".concat(theme.palette.common.white),
        borderRadius: '50%'
      },
      '&:hover': {
        backgroundColor: theme.palette.opacity.primary[900][86]
      },
      /**
       * "To style links appropriately, put the :active
       * rule after all other link-related rules,
       * as defined by the LVHA-order: :link — :visited — :hover — :active."
       * https://developer.mozilla.org/en-US/docs/Web/CSS/:active
       */
      // eslint-disable-next-line sort-keys
      '&:active': {
        backgroundColor: theme.palette.opacity.primary[900][62]
      },
      backgroundColor: theme.palette.primary[900],
      borderRadius: 0,
      color: theme.palette.common.white,
      fontSize: theme.spacing(3),
      height: theme.spacing(7),
      padding: 0,
      width: theme.spacing(7)
    },
    iconLabel: {
      height: theme.spacing(5),
      width: theme.spacing(5)
    },
    listItemFocusVisible: {},
    listRoot: {
      padding: 0
    },
    loadingWrapper: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      justifyContent: 'center',
      marginTop: theme.spacing(21),
      width: '100%'
    },
    paper: {
      width: theme.spacing(40)
    },
    pfptLogo: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },
    title: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      marginRight: '8px'
    }
  };
};
var defaultProps = {
  classes: {},
  dataMetrics: {
    appList: 'fuse_app_switcher_app_list',
    drawer: 'fuse_app_switcher_drawer',
    root: 'fuse_app_switcher'
  },
  showHomeLink: false,
  tooltip: 'App Switcher',
  variant: 'enterprise-product'
};
var MODES = {
  DEMO: 'demo',
  DEVELOPMENT: 'development',
  PRODUCTION: 'production'
};
exports.MODES = MODES;
var APP_TYPES = {
  ADMIN: 'admin',
  END_USER: 'enduser'
};
var DSP_API_URLS = (_DSP_API_URLS = {}, (0, _defineProperty2["default"])(_DSP_API_URLS, MODES.DEMO, 'https://dsp-api.lab.ppops.net/v1/appswitcher/registry/demo'), (0, _defineProperty2["default"])(_DSP_API_URLS, MODES.DEVELOPMENT, 'https://dsp-api.lab.ppops.net/v1/appswitcher/registry'), (0, _defineProperty2["default"])(_DSP_API_URLS, MODES.PRODUCTION, 'https://dsp-api.proofpoint.com/v1/appswitcher/registry'), _DSP_API_URLS);
exports.DSP_API_URLS = DSP_API_URLS;
var ERROR_DESCRIPTION = 'For an unknown reason we are unable to retrieve your app list. Please refresh the page to try again later.';
var KEY_EVENTS_MAP = {
  ArrowDown: function ArrowDown(_ref) {
    var focusedAppIndex = _ref.focusedAppIndex,
      appListItemCount = _ref.appListItemCount;
    if (focusedAppIndex === appListItemCount - 1) {
      return 0;
    }
    return focusedAppIndex + 1;
  },
  ArrowUp: function ArrowUp(_ref2) {
    var focusedAppIndex = _ref2.focusedAppIndex,
      appListItemCount = _ref2.appListItemCount;
    if (focusedAppIndex <= 0) {
      return appListItemCount - 1;
    }
    return focusedAppIndex - 1;
  },
  Escape: function Escape(_, cb) {
    cb();
    return -1;
  }
};

/**
 * App Switcher is a universal pattern used across all proofpoint products.
 * Based on the privilege of user accounts, users can browser a list of apps
 * they can access and navigate to one of them using App Switcher. App Switcher
 * provides very little configurability to ensure the consistent experience in
 * all products.
 */
var _ref4 = /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null);
var _ref5 = /*#__PURE__*/_react["default"].createElement(_Apps["default"], null);
var _ref6 = /*#__PURE__*/_react["default"].createElement(_Apps["default"], null);
var _ref7 = /*#__PURE__*/_react["default"].createElement(_ArrowForward["default"], null);
var AppSwitcher = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(AppSwitcher, _React$PureComponent);
  var _super = _createSuper(AppSwitcher);
  function AppSwitcher(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AppSwitcher);
    _this = _super.call(this, props);
    _this.handleAppSwitcherIconClick = function () {
      _this.setState(function (prevState) {
        return {
          isAppSwitcherOpen: !prevState.isAppSwitcherOpen
        };
      }, function () {
        var isAppSwitcherOpen = _this.state.isAppSwitcherOpen;
        var _this$props = _this.props,
          appType = _this$props.appType,
          mode = _this$props.mode,
          appOptions = _this$props.appOptions,
          customOptions = _this$props.customOptions;
        if (isAppSwitcherOpen && mode) {
          _this.setState({
            isLoadingViewOpen: true
          });
          if ((!appOptions || appOptions === []) && mode) {
            var url = "".concat(DSP_API_URLS[mode], "?appType=").concat(appType);
            _this.fetchApplications(url, mode).then(function (apps) {
              _this.renderAppListFromApi(apps, customOptions);
            })["catch"](function () {
              _this.renderAppListFromApi([], customOptions, true);
            });
          } else {
            _this.setState({
              isLoadingViewOpen: false
            });
          }
        }
      });
    };
    _this.renderAppListFromApi = function (apps, customOptions, isError) {
      _this.setState({
        appListFromApi: isError ? [] : _this.formatAppList(apps).concat(customOptions || []),
        isErrorViewOpen: isError,
        isLoadingViewOpen: false
      });
    };
    _this.handleAppSwitcherOptionClick = function (onClick) {
      return function () {
        _this.setState({
          isAppSwitcherOpen: false
        });
        onClick();
      };
    };
    _this.handleAppSwitcherClose = function () {
      _this.setState({
        isAppSwitcherOpen: false
      });
    };
    _this.fetchApplications = function (url, mode) {
      return window.fetch(url, {
        // include auth token when not in demo
        credentials: mode === MODES.DEMO ? 'omit' : 'include'
      }).then(function (response) {
        var contentType = response.headers.get('Content-Type');
        if (response.ok && contentType && contentType.includes('application/json')) {
          return response.json();
        }
        throw new Error();
      });
    };
    _this.formatAppList = function (apps) {
      return [{
        options: (apps || []).map(function (_ref3) {
          var displayName = _ref3.displayName,
            appUrl = _ref3.appUrl,
            appId = _ref3.appId;
          return {
            appId: appId,
            dataMetrics: "".concat(appId, "_list_item"),
            label: displayName,
            onClick: function onClick() {
              return _this.navigateToApp(appUrl);
            }
          };
        })
      }];
    };
    _this.navigateToApp = function (appUrl) {
      var a = document.createElement('a');
      a.href = appUrl;
      a.setAttribute('target', '_blank');
      a.click();
      a.remove();
    };
    _this.renderLoadingView = function (classes) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.loadingWrapper
      }, _ref4);
    };
    _this.renderError = function (classes) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.errorContainer
      }, /*#__PURE__*/_react["default"].createElement(_ReportProblem["default"], {
        className: classes.errorIcon
      }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: classes.errorDescription,
        variant: "body1"
      }, ERROR_DESCRIPTION));
    };
    _this.renderAppList = function (app, previousAppOptionsTotalLength, classes, dataMetrics, variant, listKey) {
      var currentAppId = _this.props.currentAppId;
      var focusedAppIndex = _this.state.focusedAppIndex;
      return /*#__PURE__*/_react["default"].createElement(_List["default"], {
        classes: {
          root: classes.listRoot
        },
        "data-metrics": dataMetrics.appList,
        key: listKey
      }, app.options.map(function (option, index) {
        var isFocused = focusedAppIndex === index + previousAppOptionsTotalLength;
        return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
          autoFocus: isFocused,
          button: true,
          classes: {
            focusVisible: classes.listItemFocusVisible,
            root: classes.appOption,
            selected: classes.appOptionSelected
          },
          "data-metrics": "".concat(option.appId, "_list_item"),
          key: option.label,
          onClick: _this.handleAppSwitcherOptionClick(option.onClick),
          selected: currentAppId ? currentAppId === option.appId : option.selected,
          style: !isFocused && option.selected && variant === 'enterprise-product' && option.color ? {
            backgroundColor: (0, _styles.alpha)(option.color, 0.08),
            borderLeft: "4px solid ".concat(option.color)
          } : undefined,
          tabIndex: "-1"
        }, option.icon && /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
          classes: {
            root: classes.appOptionIcon
          }
        }, option.icon), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
          classes: {
            primary: classes.appOptionLabelPrimary,
            root: classes.appOptionLabel
          },
          primary: option.label
        }));
      }));
    };
    _this.calculateAppListItemCount = function () {
      var _this$state = _this.state,
        appListFromApi = _this$state.appListFromApi,
        appListItemCount = _this$state.appListItemCount;
      var appOptions = _this.props.appOptions;
      var listItemCount = null;
      if (!appListItemCount) {
        var appListItems = appOptions || appListFromApi;
        listItemCount = appListItems.reduce(function (appTotalCount, currentAppOptions) {
          var subCount = currentAppOptions.options.length;
          return appTotalCount + subCount;
        }, 0);
        _this.setState({
          appListItemCount: listItemCount
        });
      }
      return listItemCount || appListItemCount;
    };
    _this.handleOnKeyDown = function (event) {
      var _this$state2 = _this.state,
        appListItemCount = _this$state2.appListItemCount,
        focusedAppIndex = _this$state2.focusedAppIndex;
      var listItemCount = _this.calculateAppListItemCount();
      var updatedFocusedAppIndex = typeof KEY_EVENTS_MAP[event.key] === 'function' && KEY_EVENTS_MAP[event.key]({
        appListItemCount: appListItemCount || listItemCount,
        focusedAppIndex: focusedAppIndex
      }, _this.handleAppSwitcherClose);
      if (updatedFocusedAppIndex === 0 || updatedFocusedAppIndex !== false) {
        _this.setState({
          focusedAppIndex: updatedFocusedAppIndex
        });
      }
    };
    _this.handleOnClickAway = function () {
      _this.setState({
        focusedAppIndex: -1
      });
    };
    _this.state = {
      appListFromApi: [],
      appListItemCount: 0,
      focusedAppIndex: -1,
      isAppSwitcherOpen: false,
      isErrorViewOpen: false,
      isLoadingViewOpen: false
    };
    return _this;
  }
  (0, _createClass2["default"])(AppSwitcher, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        _this$props2$appOptio = _this$props2.appOptions,
        appOptions = _this$props2$appOptio === void 0 ? [] : _this$props2$appOptio,
        classes = _this$props2.classes,
        className = _this$props2.className,
        dataMetrics = _this$props2.dataMetrics,
        DrawerProps = _this$props2.DrawerProps,
        drawerRef = _this$props2.drawerRef,
        iconButtonRef = _this$props2.iconButtonRef,
        id = _this$props2.id,
        innerRef = _this$props2.innerRef,
        mode = _this$props2.mode,
        showHomeLink = _this$props2.showHomeLink,
        tooltip = _this$props2.tooltip,
        TooltipProps = _this$props2.TooltipProps,
        variant = _this$props2.variant;
      var _this$state3 = this.state,
        isAppSwitcherOpen = _this$state3.isAppSwitcherOpen,
        isLoadingViewOpen = _this$state3.isLoadingViewOpen,
        isErrorViewOpen = _this$state3.isErrorViewOpen,
        appListFromApi = _this$state3.appListFromApi;
      var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
      var rootAttributes = {};
      if (id) rootAttributes.id = id;
      var appListItems = appOptions.length > 0 ? appOptions : appListFromApi;
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        className: className,
        "data-metrics": mergedDataMetrics.root,
        ref: innerRef
      }, rootAttributes), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], (0, _extends2["default"])({
        placement: "right",
        title: tooltip
      }, TooltipProps), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        "aria-label": "Apps Switcher",
        classes: {
          label: classes.iconLabel,
          root: classes.iconButton
        },
        color: "inherit",
        onClick: this.handleAppSwitcherIconClick,
        ref: iconButtonRef
      }, _ref5)), /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
        onClickAway: this.handleOnClickAway
      }, /*#__PURE__*/_react["default"].createElement(_Drawer["default"], (0, _extends2["default"])({
        classes: {
          paper: classes.paper
        },
        "data-metrics": mergedDataMetrics.drawer,
        ModalProps: {
          BackdropProps: {
            classes: {
              root: classes.backdrop
            }
          }
        },
        onClose: this.handleAppSwitcherClose,
        onKeyDown: this.handleOnKeyDown,
        open: isAppSwitcherOpen,
        ref: drawerRef,
        transitionDuration: 0
      }, DrawerProps), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.title
      }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        "aria-label": "Apps Switcher",
        classes: {
          label: classes.drawerIconLabel,
          root: classes.drawerIconButton
        },
        color: "inherit",
        onClick: this.handleAppSwitcherIconClick
      }, _ref6), variant === 'enterprise-product' && /*#__PURE__*/_react["default"].createElement(_ProofpointLogo["default"], {
        classes: {
          root: classes.pfptLogo
        },
        variant: "gray"
      }), showHomeLink && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: classes.home,
        href: [MODES.PRODUCTION].includes(mode) ? 'https://threatprotection.proofpoint.com' : 'https://threat-platform.c15.lab.ppops.net/',
        variant: "text",
        icon: _ref7,
        iconPosition: "right"
      }, "Home")), isLoadingViewOpen ? this.renderLoadingView(classes) : (appListItems || []).map(function (app, index) {
        var currentPreviousAppOptionsLength = appListItems.slice(0, index).reduce(function (totalCount, currentApp) {
          return totalCount + currentApp.options.length;
        }, 0);
        var currentPreviousAppOptionsCount = currentPreviousAppOptionsLength || 0;
        if (app.header) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: classes.appGroup,
            key: app.header || "appGroup-".concat(index)
          }, /*#__PURE__*/_react["default"].createElement("div", null, app.header && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
            className: classes.header,
            variant: "h6"
          }, app.header)), _this2.renderAppList(app, currentPreviousAppOptionsCount, classes, mergedDataMetrics, variant));
        }
        return _this2.renderAppList(app, currentPreviousAppOptionsCount, classes, mergedDataMetrics, variant, "appGroup-".concat(index));
      }), isErrorViewOpen && this.renderError(classes))));
    }
  }]);
  return AppSwitcher;
}(_react["default"].PureComponent);
exports.AppSwitcher = AppSwitcher;
AppSwitcher.defaultProps = defaultProps;
AppSwitcher.displayName = 'AppSwitcherClass';
AppSwitcher.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * An object that indicates how to render the content of the App Switcher.
   */
  appOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    header: _propTypes["default"].string,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      appId: _propTypes["default"].string,
      color: _propTypes["default"].string,
      icon: _propTypes["default"].element,
      label: _propTypes["default"].string.isRequired,
      onClick: _propTypes["default"].func.isRequired,
      selected: _propTypes["default"].bool
    }))
  })),
  /**
   * The application type.
   */
  appType: _propTypes["default"].oneOf([APP_TYPES.ADMIN, APP_TYPES.END_USER]),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Specify id of current application
   * Mainly used for highlighting applications returned from DSP API.
   * This prop will surpass 'selected' prop in customized appOptions.
   */
  currentAppId: _propTypes["default"].string,
  /**
   * For dsp api mode, custom app options are allowed to be appended
   * to app options fetched from dsp backend.
   * @ignore
   */
  customOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    header: _propTypes["default"].string,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      appId: _propTypes["default"].string,
      color: _propTypes["default"].string,
      icon: _propTypes["default"].element,
      label: _propTypes["default"].string.isRequired,
      onClick: _propTypes["default"].func.isRequired,
      selected: _propTypes["default"].bool
    }))
  })),
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    appList: _propTypes["default"].string,
    drawer: _propTypes["default"].string,
    root: _propTypes["default"].string
  }),
  /**
   * props to pass through the App Switcher down to the inner Drawer component.
   * See [MUI DrawerProps](https://v4.mui.com/api/drawer/#props) for more details.
   */
  DrawerProps: _propTypes["default"].object,
  /**
   * innerRef to the Drawer component inside the AppSwitcher
   */
  drawerRef: _propTypes["default"].oneOfType([
  // Either a function
  _propTypes["default"].func,
  // Or the instance of a DOM native element (see the note about SSR)
  _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Element)
  })]),
  /**
   * innerRef to the IconButton component inside the AppSwitcher
   */
  iconButtonRef: _propTypes["default"].oneOfType([
  // Either a function
  _propTypes["default"].func,
  // Or the instance of a DOM native element (see the note about SSR)
  _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Element)
  })]),
  /**
   * @ignore
   */
  id: _propTypes["default"].string,
  /**
   * @ignore
   */
  innerRef: _propTypes["default"].oneOfType([
  // Either a function
  _propTypes["default"].func,
  // Or the instance of a DOM native element (see the note about SSR)
  _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Element)
  })]),
  /**
   *
   * The mode specifies which type of DSP api should be called to get application list.
   *
   *
   *  demo:<br />
   *       -For demo purpose, fetch applications from DSP staging demo api,
   *       no authorization is required.
   *
   *  development:<br />
   *       -Fetch applications from DSP staging api
   *
   *  production:<br />
   *       -Fetch applications from DSP prod api
   *
   * When running in development/production mode, the auth token that is generated
   * by the containing application will be included into the request.
   *
   */
  mode: _propTypes["default"].oneOf([MODES.DEMO, MODES.DEVELOPMENT, MODES.PRODUCTION]),
  /**
   * controls whether to display home link in the top right corner of appswitcher. Links to the App Catalog in Threat Protection Platform.
   */
  showHomeLink: _propTypes["default"].bool,
  /**
   * Tooltip over App Switcher icon. Default value is 'App Switcher'.
   */
  tooltip: _propTypes["default"].string,
  /**
   * props to pass through the App Switcher down to the inner Tooltip component
   */
  TooltipProps: _propTypes["default"].object,
  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['enterprise-product', 'end-user-service'])
} : {};
var ExportComponent = (0, _styles.withStyles)(styles)(AppSwitcher);
ExportComponent.displayName = 'AppSwitcher';
var _default = ExportComponent;
exports["default"] = _default;